import PropTypes from 'prop-types';
import React from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';

import { bidStates } from '../../../core/api';

class BidDetailToolbar extends React.Component {
  getCommandsFromState() {
    try {
      const send = (
        <Button onClick={this.props.openSend} title="Send to hotel contact" bsStyle="info">
          <i className="fa fa-envelope fa-lg" />
          <i className="fa fa-email fa-lg" /> Send
        </Button>
      );
      const remove = (
        <Button onClick={this.props.remove} title="Remove request for bid" bsStyle="info">
          <i className="fa fa-trash fa-lg" /> Remove
        </Button>
      );
      const interested = (
        <Button
          onClick={this.props.save}
          data-item="IN"
          bsStyle="info"
          title="Mark offer as interesting."
        >
          <i className="fa fa-thumbs-up fa-lg" />Interested
        </Button>
      );
      const notinterested = (
        <Button
          onClick={this.props.save}
          data-item="PD"
          bsStyle="info"
          title="Unmark offer as interesting."
        >
          <i className="fa fa-thumbs-down fa-lg" />Not Interested
        </Button>
      );
      const decline = (
        <Button onClick={this.props.save} data-item="DE" title="Decline stay offer." bsStyle="info">
          <i className="fa fa-times fa-lg" /> Decline Bid
        </Button>
      );
      const accept = (
        <Button
          onClick={this.props.save}
          data-item="AC"
          bsStyle="info"
          title="Accept hotel for this stay. Will decline other pending bids."
        >
          <i className="fa fa-save fa-lg" /> Accept Bid
        </Button>
      );
      const reopen = (
        <Button onClick={this.props.save} data-item="ST" bsStyle="info">
          <i className="fa fa-pencil fa-lg" /> Re-open Bid
        </Button>
      );
      const prebook = (
        <Button
          onClick={this.props.save}
          data-item="PB"
          title="Accept hotel as already booked outside of Catch."
          bsStyle="info"
        >
          <i className="fa fa-hotel fa-lg" /> Prebook
        </Button>
      );

      if (this.props.isTourManager) {
        const bidCommands2 = {
          Draft: { Unsent: [] },
          Sent: {
            Unread: [],
            Viewed: [],
            Replied: [interested],
            Nobid: [],
          },
          Pending: {
            Replied: [interested],
          },
          Interested: {
            Replied: [notinterested],
            Cancel: [],
          },
          Decline: {
            Declined: [],
          },
          Accept: {
            Replied: [],
            Accepted: [],
          },
          Contracted: {
            Contracted: [],
          },
          Prebooked: {
            Unsent: [],
          },
        };
        return bidCommands2[bidStates[this.props.bid.buyer_state]][
          bidStates[this.props.bid.bidder_state]
        ];
      }
      const bidCommands = {
        Draft: { Unsent: [send, prebook, remove] },
        Sent: {
          Unread: [send],
          Viewed: [send],
          Replied: [interested, accept, decline],
          Nobid: [],
        },
        Pending: {
          Replied: [interested, decline, accept],
        },
        Interested: {
          Replied: [notinterested, accept, decline],
          Cancel: [],
        },
        Decline: {
          Declined: [reopen],
        },
        Accept: {
          Replied: [decline],
          // TODO:  Accepted: ['Approve Contract', decline],
          Accepted: [decline],
        },
        Contracted: {
          Contracted: [],
        },
        Prebooked: {
          Unsent: [reopen],
          Draft: [reopen],
        },
      };
      return bidCommands[bidStates[this.props.bid.buyer_state]][
        bidStates[this.props.bid.bidder_state]
      ];
    } catch (e) {
      console.log(e);
      // For bad states not commands are returned
      return [];
    }
  }
  render() {
    const commands = this.getCommandsFromState();
    if (!commands) {
      return null;
    }
    const toolbar = commands.map(command => command);
    return <ButtonToolbar style={{ float: 'right' }}>{toolbar}</ButtonToolbar>;
  }
}

BidDetailToolbar.propTypes = {
  bid: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  openSend: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
};

export default BidDetailToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailToolbar.js